module.exports = __webpack_public_path__ + "static/media/sn.d394962d.webp";